import { Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { QuestionOptionObj } from '../questionOption';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { messageService } from 'src/app/message.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';

@Component({
  selector: 'app-assessment-option',
  templateUrl: './assessment-option.component.html',
  styleUrls: ['./assessment-option.component.scss']
})
export class AssessmentOptionDialogComponent implements OnChanges {

  optionImage: any;
  isFileValid = false;
  isProcessing = false;

  @Input() questionData: any = {};
  optionsList: QuestionOptionObj[] = [];
  optionData: QuestionOptionObj = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";
  dropDownForQuestionType: any = [];

  showingRowsText = "Showing rows";
  perPage = 5;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;

  visibleAddOrEditOptionPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteOptionPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditOptionPopup', { static: true }) addOrEditOptionPopup: TemplateRef<any>;
  @ViewChild('deleteOptionPopup', { static: true }) deleteOptionPopup: TemplateRef<any>;

  addOrEditOptionPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteOptionPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  };


  constructor(public appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog, public message: messageService) {

  }

  questionName: string = '';
  contentName: string = '';
  trainingName: string = '';
  ngOnChanges(changes: SimpleChanges): void {
    this.isProcessing = true;
    this.appService.getQuestionOptionsList(this.questionData['trainingId'],
      this.questionData['version'], this.questionData['contentId'], this.questionData['questionId']).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.optionsList = data;
          this.collectionSize = this.optionsList.length;
          if (data.length && data[0]) {
            this.questionName = data[0].question;
            this.contentName = data[0].content;
            this.trainingName = data[0].trainingName;
          }
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
  }

  refreshGrid() {
    this.isProcessing = true;
    this.appService.getQuestionOptionsList(this.questionData['trainingId'],
      this.questionData['version'], this.questionData['contentId'], this.questionData['questionId']).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.optionsList = data;
          this.collectionSize = this.optionsList.length;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.optionsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.optionsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.optionsList) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.optionsList) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }


  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.optionImage = file;
      this.optionData.optionImageExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "TMS");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.isFileValid = true;

            } else {
              this.isFileValid = false;
              this.optionImage = null;
              this.optionData.optionImageExtn = '';
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    } else {
      this.optionImage = '';
      this.optionData.optionImageExtn = '';
    }
  }

  addOptionFunc() {
    this.optionData['optionCode'] = "";
    this.optionData['optionValue'] = "";
    this.optionData['optionImageExtn'] = "";
    this.optionData['trainingId'] = this.questionData['trainingId'];
    this.optionData['version'] = this.questionData['version'];
    this.optionData['contentId'] = this.questionData['contentId'];
    this.optionData['questionId'] = this.questionData['questionId'];
    this.optionImage = null;
    this.operationFlag = "ADD";
    this.isDuplicateOptionCode = false;
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = "Add Option";
    this.visibleAddOrEditOptionPopup = this.dialog.open(this.addOrEditOptionPopup, this.addOrEditOptionPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditOptionPopup.close();
  }

  isDuplicateOptionCode: boolean = false;
  addAndEditFunction(option: any) {
    this.isDuplicateOptionCode = false;
    this.isProcessing = true;
    if (option['optionCode'] == "" || option['optionValue'] == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      for (const element of this.optionsList) {
        if (element.optionCode == option['optionCode']) {
          this.isDuplicateOptionCode = true;
        }
      }
      if (this.isDuplicateOptionCode) {
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: "Option code is already exist, please enter different option code.",
            type: 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else {
        option['operation'] = "I";
        const formData = new FormData();
        formData.append('file', this.optionImage);
        const json = JSON.stringify(option);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('trainingQuestionOptionsDto', blob);
        this.appService.addOrUpdateQuestionOption(formData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.fieldValidation();
              this.visibleAddOrEditOptionPopup.close();
              this.isProcessing = true;
              this.appService.getQuestionOptionsList(this.questionData['trainingId'],
                this.questionData['version'], this.questionData['contentId'], this.questionData['questionId']).subscribe({
                  next: (data: any) => {
                    this.isProcessing = false;
                    this.optionsList = data;
                    this.collectionSize = this.optionsList.length;
                  }, error: (error) => {
                    this.isProcessing = false;
                    throw error;
                  }
                });
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }

    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

  }

  optionCode: any;
  optionValue: any;

  optionCodeRequiredMsg: any;
  optionValueRequiredMsg: any;

  fieldValidation() {
    this.optionCode = document.getElementById('optionCode') as HTMLInputElement;
    this.optionValue = document.getElementById('optionValue') as HTMLInputElement;

    this.optionCodeRequiredMsg = document.getElementById('optionCode-required-msg') as HTMLInputElement;
    this.optionValueRequiredMsg = document.getElementById('optionValue-required-msg') as HTMLInputElement;

    if (this.optionData.optionCode == "") {
      this.optionCode.style.border = '1px solid red';
      this.optionCodeRequiredMsg.style.display = 'block';
    } else {
      this.optionCode.style.border = 'none';
      this.optionCodeRequiredMsg.style.display = 'none';
    }
    if (this.optionData.optionValue == "") {
      this.optionValue.style.border = '1px solid red';
      this.optionValueRequiredMsg.style.display = 'block';
    } else {
      this.optionValue.style.border = 'none';
      this.optionValueRequiredMsg.style.display = 'none';
    }
  }

  openDeletePopup(option: any) {
    this.optionData = option;
    this.optionData['deleteReason'] = "";
    this.title = "Delete Option";
    this.visibleDeleteOptionPopup = this.dialog.open(this.deleteOptionPopup, this.deleteOptionPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteOptionPopup.close();
  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.optionData['deleteReason'] == "") {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      delete this.optionData['createdOn'];
      delete this.optionData['updatedOn'];
      this.appService.deleteQuestionOption(this.optionData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.deleteValidation();

          }
          this.visibleDeleteOptionPopup.close();
          this.isProcessing = true;
          this.appService.getQuestionOptionsList(this.questionData['trainingId'],
            this.questionData['version'], this.questionData['contentId'], this.questionData['questionId']).subscribe({
              next:
                (data: any) => {
                  this.isProcessing = false;
                  this.optionsList = data;
                  this.collectionSize = this.optionsList.length;
                }, error: (error) => {
                  this.isProcessing = false;
                  throw error;
                }
            });
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });

    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

  }

  deleteReason: any;

  deleteReasonRequiredMsg: any;

  deleteValidation() {
    this.deleteReason = document.getElementById('deleteReason') as HTMLInputElement;

    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.optionData.deleteReason == "") {
      this.deleteReason.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReason.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, option: any) {
    this.isProcessing = true;
    this.appService.getQuestionOptionsList(this.questionData['trainingId'],
      this.questionData['version'], this.questionData['contentId'], this.questionData['questionId']).subscribe({
        next: (data: any) => {
          if (data.length && data[0]) {
            this.questionName = data[0].question;
            this.contentName = data[0].content;
            this.trainingName = data[0].trainingName;
          }
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    if (viewType == 'overAll') {
      this.message.tableOrView_Name = "TMS_TRAINING_QUESTION_OPTIONS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,OPTION_CODE,OPTION_IMAGE,OPTION_IMAGE_EXTN,OPTION_VALUE,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Option Code,Option Image,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
      this.message.whereClause_AU = " AND TRAINING_ID=" + this.questionData.trainingId + " AND CONTENT_ID=" + this.questionData.contentId + " AND QUESTION_ID=" + this.questionData.questionId + " AND VERSION=" + this.questionData.version;
      this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Option Code,Option Image,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
      this.message.whereClause_Report = " WHERE TRAINING_ID=" + this.questionData.trainingId + " AND CONTENT_ID=" + this.questionData.contentId + " AND QUESTION_ID=" + this.questionData.questionId + " AND VERSION=" + this.questionData.version;
      this.message.report_And_Popup_Name = 'Training Options Audit Trail ';
      this.staticAuditTrailComponent.triggerTrail(option);
    } else {
      this.message.tableOrView_Name = "TMS_TRAINING_QUESTION_OPTIONS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,OPTION_CODE,OPTION_IMAGE,OPTION_IMAGE_EXTN,OPTION_VALUE,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Option Code,Option Image,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By";
      this.message.whereClause_AU = " AND TRAINING_ID=" + option.trainingId + " AND CONTENT_ID=" + option.contentId + " AND QUESTION_ID=" + option.questionId + " AND OPTION_ID=" + option.optionId + " AND VERSION=" + option.version;
      this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Option Code,Option Image,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By";
      this.message.whereClause_Report = " WHERE TRAINING_ID=" + option.trainingId + " AND CONTENT_ID=" + option.contentId + " AND QUESTION_ID=" + option.questionId + " AND OPTION_ID=" + option.optionId + " AND VERSION=" + option.version;
      this.message.report_And_Popup_Name = 'Training Options Audit Trail';
      this.staticAuditTrailComponent.triggerTrail(option);
    }
    this.isProcessing = false;
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_TRAINING_QUESTION_OPTIONS_VW";
    this.excelPdf.columnList_DB = "OPTION_CODE,OPTION_IMAGE_EXTN,OPTION_VALUE,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
    this.excelPdf.columnList_Report = "Option Code,Option Image Extension,Option Value,Version,Created On,Created By,Updated On,Updated By";
    this.excelPdf.whereClause_Report = " WHERE TRAINING_ID=" + this.questionData.trainingId + " AND CONTENT_ID=" + this.questionData.contentId + " AND QUESTION_ID=" + this.questionData.questionId + " AND VERSION=" + this.questionData.version;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Training Options Report [' + this.trainingName + ' (V-' + this.questionData.version + ') ' + this.contentName + ' ' + this.questionName + ']';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

}
